export default {
  questionAnswers(state) {
    let groupId = 1
    //
    const questionAnswers = _.cloneDeep(state.questionAnswers)
    return _.map(questionAnswers, (data) => {
      //
      _.set(data, 'group_id', groupId)
      _.set(data, 'open', false)
      let itemId = 1
      //
      const qaData = _.map(data.qa_data, (item) => {
        const fullId = `${groupId}${itemId}`
        _.set(item, 'item_id', fullId)
        itemId += 1
        return item
      })
      //
      _.set(data, 'qa_data', qaData)
      groupId += 1
      return data
    })
  },
  questionAnswers2(state) {
    const questionAnswers = _.cloneDeep(state.questionAnswers)
    return _.map(questionAnswers, (data) => {
      return data
    })
  },
  questionAnswers3(state) {
    const questionAnswers = _.cloneDeep(state.questionAnswers)
    const map = _.map(questionAnswers)
    const flatten = _.flattenDeep(map)
    const num = (state.currentId) * 1
    const find = _.find(flatten, { id: num })
    return find
  },
  categories(state) {
    return state.category.filter(categories => categories.name !== '未分類')
  },
  // beta(state) {
  //   const { name } = state.category[0]
  //   return state.questionAnswers.filter(questionAnswers => `${questionAnswers.category_name}` === name)
  // },
  // usage(state) {
  //   const { name } = state.category[1]
  //   return state.questionAnswers.filter(questionAnswers => `${questionAnswers.category_name}` === name)
  // },
  // price(state) {
  //   const { name } = state.category[2]
  //   return state.questionAnswers.filter(questionAnswers => `${questionAnswers.category_name}` === name)
  // },
  only_beta(state) {
    const num = process.env.VUE_APP_WP_BETA_CATEGORY
    return state.questionAnswers.filter(questionAnswers => `${questionAnswers.categories[0]}` == num)// eslint-disable-line eqeqeq

  },
  only_service(state) {
    const num = process.env.VUE_APP_WP_SERVICE_CATEGORY

    //console.log("-----------",state.questionAnswers.filter(questionAnswers => `${questionAnswers.category_name}` === "サービスの概要に関するご質問"))
    //return state.questionAnswers.filter(questionAnswers => `${questionAnswers.categories}` === num)
    return state.questionAnswers.filter(questionAnswers => `${questionAnswers.category_name}` === "サービスの概要に関するご質問")
  },
  getIsOpened(state) {
    return state.isOpened
  }
}
